import { useContext } from 'react';
import LayoutManagerContext from "./LayoutManagerContext.js";
/**
 * Retrieve the current LayoutManager from the context
 */
function useLayoutManager() {
  var layoutManager = useContext(LayoutManagerContext);
  if (layoutManager == null) {
    throw new Error('LayoutManager not available, did you add a LayoutManagerContext.Provider to the tree?');
  }
  return layoutManager;
}
export default useLayoutManager;
//# sourceMappingURL=useLayoutManager.js.map